// types
import {
  ConfigProps,
  MenuOrientation,
  ThemeDirection,
  ThemeMode,
} from '@app/types/config';

export const DASHBOARD_PATH = '/home';
export const HORIZONTAL_MAX_ITEM = 7;
export const LOGIN_PATH = '/sign-in';

const config: ConfigProps = {
  menuOrientation: MenuOrientation.VERTICAL,
  miniDrawer: false,
  fontFamily: `'Inter Variable', sans-serif`,
  borderRadius: 10,
  outlinedFilled: true,
  mode: ThemeMode.LIGHT,
  presetColor: 'theme2',
  i18n: 'en',
  themeDirection: ThemeDirection.LTR,
  container: false,
};

export default config;
